module.exports = __webpack_public_path__ + "static/media/footer_popup_store_icon.7d5eb559.svg";